const orderLineStatuses = {
	acknowledged: 'acknowledged',
	booked: 'booked',
	cancelled: 'cancelled',
	confirmed: 'confirmed',
	created: 'created',
	delivered: 'delivered',
	entered: 'entered',
	picked: 'picked',
	refund: 'refund',
	shipped: 'shipped',
};

const orderLineStatusesForSplit = [
	orderLineStatuses.acknowledged,
	orderLineStatuses.booked,
	orderLineStatuses.confirmed,
	orderLineStatuses.created,
	orderLineStatuses.entered,
	orderLineStatuses.picked,
];

export { orderLineStatuses, orderLineStatusesForSplit };



// WEBPACK FOOTER //
// ./src/common/constants/marketplaceOrderConstants.js